import { SearchOption } from "../modules/components/type";
import { ResponseTeam } from "../type";

export function teamToOption(team: ResponseTeam) {
  return {
    userId: null,
    teamId: team.id,
    name: team.name,
  } as SearchOption;
}